<template>
  <div>
    <div class="columns is-vcentered">
      <div class="column is-narrow">
        <figure>
          <p class="image is-128x128">
            <img
              src="https://www.prostock.com.au/wp-content/uploads/Greg.jpg"
              style="border-radius:10rem"
              alt="site.sitename"
            />
          </p>
        </figure>
      </div>
      <div class="column">
        <h1 class="title">
          Greg Nash
        </h1>
        <h2 class="subtitle">Agent subtitle</h2>
      </div>
    </div>
    <h2 class="title">Markets</h2>
    <figure class="stacked-imgs mb-6">
      <!-- <span v-for="(p, index) in agents" :key="index" class="stacked">
        <img
          :src="'https://my.biddingmate.com.au/logos/' + p.site + '.png'"
          class="image is-64x64"
        />
      </span> -->

      <a href="#" class="stacked">
        <img
          src="https://my.biddingmate.com.au/logos/southernlx.png"
          class="image is-64x64"
        />
      </a>

      <a href="#" class="stacked">
        <img
          src="https://my.biddingmate.com.au/logos/bohning.png"
          class="image is-64x64"
        />
      </a>
    </figure>
  </div>
</template>

<style scoped>
.upnext {
  background-color: #17784d;
  border-radius: 12px;
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
  position: relative;
}
.stacked-imgs {
  display: inline-flex;
  flex-direction: row-reverse;
  transform: scale(-1, 1);
}

.stacked {
  position: relative;
  overflow: hidden;
}

.stacked:not(:last-child) {
  margin-left: -2.5rem;
}

.stacked img {
  display: block;
  transform: scale(-1, 1);
  border: 4px solid #161a25;
  border-radius: 50%;
}
.stacked-imgs .tag {
  position: fixed;
  transform: scale(-1, 1);
  bottom: 0;
  z-index: 1;
}
</style>

<script>
import log from 'loglevel'
import { proapps } from '../common/proapps'

export default {
  name: 'Agent',
  metaInfo() {
    return {
      title: 'Agent Profile',
      meta: [
        {
          name: 'description',
          content: 'Agent Profile'
        }
      ]
    }
  },
  data() {
    return {
      description: '',
      sitesAvailable: false,
      sites: []
    }
  },
  mounted() {
    log.info('Agent mounted')

    // Get sites
    proapps
      .getSites()
      .then(response => {
        this.sites = response
        this.sitesAvailable = true
      })
      .catch(err => {
        log.error(err)
      })
  },
  destroyed() {
    log.info('Agent destroyed')
  }
}
</script>
